export default {
    mapBoxToken: "pk.eyJ1IjoicGFya2VhZ2xlIiwiYSI6ImNrNDJqczRtNjAxMHgzbm9rYWhkbjI0ZTkifQ.bMsg3bpZzZAz3LhudNzRlQ"
};
